import React, { Component } from 'react';
// 引入编辑器组件
import BraftEditor from 'braft-editor'
// 引入编辑器样式
import 'braft-editor/dist/index.css'

import * as qiniu from 'qiniu-js'
import request from '../../utils/request'
import { message, } from 'antd';
import { ContentUtils } from 'braft-utils'

const prexUrl = "https://file.daries.com.cn/"

class LmmEdit extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            istext:false,
        }
    }

    myUploadFn = async file => {
        
        let config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          };
          
          let key = file.file.name
        
          let putExtra = {
            fname: key,
            params: {},
            mimeType: null
          };
        
          request({
              method:'post',
              url:this.props.tokenUrl,
            }).then(data => {
              var observable = qiniu.upload(file.file, key, data, putExtra, config)
              var observer = {
                next(res){
                  console.log("qiniu-next")
                  console.log(res)
                },
                error(err){
                  console.log("qiniu-err")
                  console.log(err)
                  message.error(`${file.file.name} 上传失败`);
                }, 
                complete(res){
                  console.log("qiniu-complete")
                  message.success(`${file.file.name} 上传成功`);
        
              
                  file.success({ url: prexUrl + key })
                }
              }
              var subscription = observable.subscribe(observer) // 上传开始
            })
        
        }

  triggerChange = changedValue => {
    const { onChange } = this.props;
    if (onChange) {
        // if (this.state.istext){
        //     console.log(changedValue)
        //     onChange(changedValue.text);
        // }else{
            onChange(changedValue.toHTML());
        // }
    }
  };

  preview = () => {

    if (window.previewWindow) {
      window.previewWindow.close()
    }

    window.previewWindow = window.open()
    window.previewWindow.document.write(this.buildPreviewHtml())
    window.previewWindow.document.close()

  }

  buildPreviewHtml () {
    
    return `
      <!Doctype html>
      <html>
        <head>
          <title>Preview Content</title>
          <style>
            html,body{
              height: 100%;
              margin: 0;
              padding: 0;
              overflow: auto;
              background-color: #f1f2f3;
            }
            .container{
              box-sizing: border-box;
              width: 1000px;
              max-width: 100%;
              min-height: 100%;
              margin: 0 auto;
              padding: 30px 20px;
              overflow: hidden;
              background-color: #fff;
              border-right: solid 1px #eee;
              border-left: solid 1px #eee;
            }
            .container img,
            .container audio,
            .container video{
              max-width: 100%;
              height: auto;
            }
            .container p{
              white-space: pre-wrap;
              min-height: 1em;
            }
            .container pre{
              padding: 15px;
              background-color: #f1f1f1;
              border-radius: 5px;
            }
            .container blockquote{
              margin: 0;
              padding: 15px;
              background-color: #f1f1f1;
              border-left: 3px solid #d1d1d1;
            }
          </style>
        </head>
        <body>
          <div class="container">${BraftEditor.createEditorState(this.props.value).toHTML()}</div>
        </body>
      </html>
    `

  }

  render() {
    const { value,style,onChange } = this.props;

    let initValue = value;

    if (value != undefined){
      initValue = BraftEditor.createEditorState(value);
    }

    const extendControls = [
        {
          key: 'custom-button',
          type: 'button',
          text: '预览',
          onClick: this.preview
        }
      ]

    // const extendControls = [
    //     {
    //         key: 'custom-button',
    //         type: 'button',
    //         text: '按钮',
    //         onClick: () => {
    //             this.setState({istext:true})
    //         }
    //       },
    //    {
    //       key: 'custom-modal',
    //       type: 'modal',
    //       text: '模态框',
    //       onClick: () => {
    //         onChange("<p></p>")
    //       },
    //       modal: {
    //         id: 'my-moda-1',
    //         title: '纯文本',
    //         confirmable: true,
    //         onConfirm: () => {
    //             console.log("输入纯文本内容")
    //            this.triggerChange( ContentUtils.insertText('', '<p></p>'))
    //             // onChange( ContentUtils.insertText('', '<p></p>'))
    //         },
    //         children: (
    //           <div style={{width: 400, padding: '0 10px'}}>
    //             <input />
    //           </div>
    //         )
    //       }
    //     }
    //   ]

    return (
      <div style={style}>
        <BraftEditor
          media={{ uploadFn: this.myUploadFn }}
          value={value}
          stripPastedStyles={true}
          defaultValue={initValue}
          extendControls={extendControls}
          onChange={this.triggerChange}
        />
      </div>
    );
  }

};
export default LmmEdit


// WEBPACK FOOTER //
// ./src/components/Edit/LmmEdit.js